import { useEffect, useRef, useState } from 'react';

/**
 * Reveal — animation d'apparition douce au scroll.
 *
 * Correctifs 2026-08-28 :
 *  - Respect strict de prefers-reduced-motion (jamais d'animation, contenu visible d'emblée)
 *  - Fallback SEO : si IntersectionObserver indisponible (crawlers non-JS anciens),
 *    on affiche le contenu immédiatement au lieu de le laisser en opacity:0.
 *  - Une seule observation, désabonnement propre.
 */
export function Reveal({ children, delay = 0, className = '' }) {
  const reducedMotion = typeof window !== 'undefined' && window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
    : false;

  const ref = useRef(null);
  // Si reduced-motion OU pas d'IO → visible immédiatement (SEO + accessibilité)
  const [visible, setVisible] = useState(
    reducedMotion || typeof IntersectionObserver === 'undefined'
  );

  useEffect(() => {
    if (visible) return; // déjà visible (reduced-motion / fallback)
    if (!ref.current) return;
    const obs = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setTimeout(() => setVisible(true), delay);
        obs.disconnect();
      }
    }, { threshold: 0.12, rootMargin: '0px 0px -5% 0px' });
    obs.observe(ref.current);
    return () => obs.disconnect();
  }, [delay, visible]);

  return (
    <div ref={ref} className={`reveal ${visible ? 'visible' : ''} ${className}`}>
      {children}
    </div>
  );
}
